// extracted by mini-css-extract-plugin
export default {"OfflineContainer":"Offline_OfflineContainer__VE-Qf","comingsoonicon":"Offline_comingsoonicon__09uNL"};